import { PROFILE_ACTIVE_TAB } from "../../Redux/action.type";

export const setProfileActiveTab = (data) => {
  return {
    type: PROFILE_ACTIVE_TAB,
    payload: data,
  };
};
